import React, { useEffect, useRef } from 'react';
import '../styles/Home.css';

const Home: React.FC = () => {
  const sceneRef = useRef<HTMLDivElement>(null);

  useEffect(() => {
    const scene = sceneRef.current;
    if (!scene) {
      return;
    }

    const updateScale = () => {
      const scale = window.innerWidth < 768
        ? Math.min(1, window.innerWidth / 1440)
        : 1;

      scene.style.setProperty('--scene-scale', String(scale));
      scene.style.setProperty('--scene-height', `${900 * scale}px`);
    };

    updateScale();
    window.addEventListener('resize', updateScale, { passive: true });

    return () => window.removeEventListener('resize', updateScale);
  }, []);

  return (
    <div className="home-container">
      <div ref={sceneRef} className="spline-scene-frame">
        <iframe
          src="https://my.spline.design/thebluemarble-ceUMe5X6TRu9xIijySTii64T/"
          frameBorder="0"
          allow="autoplay; fullscreen; xr-spatial-tracking"
          allowFullScreen
          loading="eager"
          className="spline-iframe"
          title="3D Blue Marble Model"
        />
      </div>
    </div>
  );
};

export default Home;
